<template>
    <section>
        <b-tabs>
            <b-tab :title="wallServicesTabTitle" class="mt-3 ">
                <h1 class="sr-only">
                    {{ wallServicesTabTitle }}
                </h1>

                <div class="text-right">
                    <b-btn
                        :disabled="pendingServices"
                        @click="fetchWallServices()"
                    >
                        <fa :spin="pendingServices" icon="sync" />
                    </b-btn>
                </div>

                <template v-for="(service, index) in services">
                    <services-to-complete-item
                        v-if="service.is_foundation_service"
                        :key="`foundation_${service.id}`"
                        :api-url="`/api/walls/${wallId}/foundation_services_to_complete`"
                        :project-id="projectId"
                        :value="service"
                        class="mb-3"
                        @completed="handleWallServiceCompleted($event, index)"
                        @deleted="services.splice(services.indexOf($event), 1)"
                    />
                    <services-to-complete-item
                        v-else
                        :key="service.id"
                        :api-url="`/api/walls/${wallId}/services_to_complete`"
                        :project-id="projectId"
                        :value="service"
                        class="mb-3"
                        @completed="handleWallServiceCompleted($event, index)"
                        @deleted="services.splice(services.indexOf($event), 1)"
                    />
                </template>

                <div v-show="pendingServices" class="text-center my-3">
                    <b-spinner small />
                </div>

                <no-results-found v-if="!pendingServices && !services.length" class="mt-3" />
            </b-tab>

            <b-tab :title="$t('Wall element services')" class="mt-3">
                <h1 class="sr-only">
                    {{ $t('Wall element services') }}
                </h1>

                <div class="text-right">
                    <b-btn
                        :disabled="pendingElements"
                        @click="fetchElementServices()"
                    >
                        <fa :spin="pendingElements" icon="sync" />
                    </b-btn>
                </div>

                <section
                    v-for="element in elementsWithServices"
                    :key="`element_${element.id}`"
                    class="mb-5"
                >
                    <h2 class="h4" v-html="element.toString" />

                    <services-to-complete-item
                        v-for="(service, index) in element.services"
                        :key="`element_${element.id}_service_${service.id}`"
                        :api-url="`/api/wall_element_service_completion/${wallId}/${element.id}/${service.id}`"
                        :project-id="projectId"
                        :value="service"
                        class="mb-3"
                        @completed="handleElementServiceCompleted($event, element.id, index)"
                    />
                </section>

                <div v-show="pendingElements" class="text-center my-3">
                    <b-spinner small />
                </div>

                <no-results-found v-if="!pendingElements && !elementsWithServices.length" class="mt-3" />
            </b-tab>
        </b-tabs>
    </section>
</template>

<script>
    import ServicesToCompleteItem from "@/components/ServicesToCompleteItem";

    export default {
        name: "WallServicesToComplete",
        components: {ServicesToCompleteItem},
        props: {
            wallId: {
                type: [Number, String],
                required: true
            },
            projectId: {
                type: [Number, String],
                required: true
            },
        },
        data() {
            return {
                services: [],
                elements: [],
                showWallServices: true,
                pendingServices: false,
                pendingFoundationServices: false,
                pendingElements: false
            }
        },
        computed: {
            elementsWithServices() {
                return this.elements.filter(element => element.services.length);
            },

            wallServicesCount() {
                if (!this.services) return 0;

                return this.services.length;
            },

            wallServicesCompletedCount() {
                if (!this.services) return 0;

                return this.services.filter(wallService => {
                    if (!wallService.info || !wallService.info.completed_steps) return false;

                    return wallService.steps === wallService.info.completed_steps.length;
                }).length;
            },

            wallServicesTabTitle() {
                return `${this.$t('Wall services')} (${this.wallServicesCompletedCount} / ${this.wallServicesCount})`;
            },
        },
        created() {
            this.fetchData();

            this.$root.$on('saved::wall-service', this.fetchWallServices);
            this.$root.$on('saved::element-service', this.fetchElementServices);
        },
        beforeDestroy() {
            this.$root.$off('saved::wall-service', this.fetchWallServices);
            this.$root.$off('saved::element-service', this.fetchElementServices);
        },
        methods: {
            handleWallServiceCompleted(data, index) {
                this.services[index].completed_steps = this.services[index].completed_steps || [];
                this.services[index].completed_steps.push(data);
            },

            handleElementServiceCompleted(data, elementId, index) {
                let element = this.elements.find(element => element.id === elementId);
                element.services[index].completed_steps.push(data);
            },

            fetchData() {
				        this.fetchElementServices();
                this.fetchWallServices();
            },

            fetchWallServices() {
                if (this.pendingServices) {
                    return;
                }

                this.pendingServices = true;

                this.axios.get(`/api/walls/${this.wallId}/services_to_complete`).then(({data}) => {
                    this.services = data
                }).finally(() => {
                    this.pendingServices = false;
                });
            },

            fetchElementServices() {
                if (this.pendingElements) {
                    return;
                }

                this.pendingElements = true;

                this.axios.get(`/api/wall_element_service_completion/${this.wallId}`).then(({data}) => {
                    this.elements = data
                }).finally(() => {
                    this.pendingElements = false;
                });
            }
        }
    }
</script>
